import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import RevealText from '../atoms/RevealText';
import { SHOWREEL_VIDEO } from '../../data';

const ShowreelTeaser = ({ onVideoClick }) => {
    return (
        <section className="py-20 px-6 md:px-12 bg-[#fbfbf4] text-[#050505]">
            <div className="flex flex-col md:flex-row gap-12 items-center">
                <motion.div
                    initial={{ clipPath: "inset(0 100% 0 0)" }}
                    whileInView={{ clipPath: "inset(0 0% 0 0)" }}
                    viewport={{ once: true }}
                    transition={{ duration: 1, ease: [0.76, 0, 0.24, 1] }}
                    className="w-full md:w-1/2 relative group cursor-pointer"
                    onClick={onVideoClick}
                >
                    <div className="aspect-video overflow-hidden rounded-sm">
                        <video src={SHOWREEL_VIDEO} autoPlay muted loop className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700" />
                    </div>
                    <div className="absolute bottom-6 right-6 px-6 py-3 bg-white text-black rounded-full text-xs uppercase tracking-widest font-bold flex items-center gap-2 group-hover:scale-105 transition-transform">
                        Showreel <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></div>
                    </div>
                </motion.div>
                <div className="w-full md:w-1/2 md:pl-12">
                    <h2 className="font-migra text-4xl md:text-7xl mb-8 leading-tight">
                        <RevealText>Crafting competitive</RevealText>
                        <RevealText className="italic text-[#888]">digital authority.</RevealText>
                    </h2>
                    <motion.p
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        transition={{ delay: 0.5 }}
                        className="text-lg md:text-xl font-light leading-relaxed max-w-md mb-8"
                    >
                        I am zxenxi, a passionate Web Developer. I transform complex problems into elegant, high-performance web solutions. My focus is on writing clean, efficient code that powers the next generation of digital products.
                    </motion.p>
                    <Link to="/about" className="inline-flex items-center gap-2 border-b border-black pb-1 hover:opacity-50 transition-opacity uppercase text-xs tracking-widest font-bold">
                        More about me <ArrowRight size={14} />
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default ShowreelTeaser;
